// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#C5DAF7",
	"menuActiveText": "#80FFF7",
	"subMenuActiveText": "#80FFF7",
	"menuBg": "transparent",
	"menuHover": "transparent",
	"subMenuBg": "transparent",
	"subMenuHover": "transparent",
	"sideBarWidth": "264px",
	"menuContainerBg": "linear-gradient(180deg, #488CE8 0%, #0058CF 100%)"
};
module.exports = exports;
